/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Document: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      d='M18.9998 2.5C19.3171 2.5 19.6159 2.65098 19.8044 2.90625C19.9928 3.16145 20.049 3.49077 19.9558 3.79395C19.0291 6.80543 19.3653 9.10659 19.7986 11.6445C20.2349 14.1998 20.7731 17.0005 19.9783 20.71C19.8794 21.1709 19.4712 21.5 18.9998 21.5H4.99976C4.69795 21.4999 4.41219 21.3636 4.22241 21.1289C4.03256 20.8941 3.95894 20.5853 4.02222 20.29C4.72713 16.9999 4.26561 14.55 3.8269 11.9805C3.38523 9.39351 2.97128 6.69441 4.04468 3.20605C4.17375 2.78659 4.5609 2.50016 4.99976 2.5H18.9998ZM5.7605 4.5C5.08552 7.17352 5.39973 9.30838 5.79858 11.6445C6.18616 13.9146 6.6517 16.3776 6.19409 19.5H18.1707C18.6503 16.5987 18.2298 14.3401 17.8269 11.9805C17.4414 9.72246 17.0775 7.37917 17.7048 4.5H5.7605ZM14.9998 10H7.99976V8H14.9998V10Z'
      fill='currentColor'
    />
  </React.Fragment>
)
